export const environment = {
	production: false,
	organizationName: 'SENRI',
	applicationName: 'Sales Import App',
	apiBaseUrl: 'https://import-app-dev.afri-inc.com/api/',
	allowedUrls: [ 'https://import-app-dev.afri-inc.com/api' ],
	tokenIssuer: 'https://import-identity-dev.afri-inc.com',
	confirmEmailCallbackUrl: 'https://import-app-dev.afri-inc.com/account/confirm-email',
	resetPasswordCallbackUrl: 'https://import-app-dev.afri-inc.com/account/reset-password',
	portalLink: 'https://import-app-dev.afri-inc.com',
	authApiBaseUrl: 'https://import-app-dev.afri-inc.com/api'
};
